import { useContext } from 'react';
import { VoipContext } from '../context/voip-context';
export const useVoipContext = () => {
    const context = useContext(VoipContext);
    if (context === null) {
        throw new Error('useVoipContext should use in VoipContext.Provider');
    }
    return context;
};
